<template>
  <div class="main">
    <div class="mt-2">
      <label for="select-img-tank">{{ $t('selecione-a-imagem-de-um-tanque') }}</label>
      <b-select name="select-img-tank" id="select-img-tank" v-model="imgSelected" :options="tanks">
      </b-select>
    </div>
    <div>
      <img class="img-tanque" :title="node.title" :src="require('@/assets/Fluxogramas/' +  imgSelected)">
    </div>
  </div>
</template>

<script>
import Tanks from "./tanques"

  export default {
    name:"FormTanque",
    props: {
      node: {
        type: Object,
        default: null,
      },
    },

    data() {
      return {
        imgSelected: this.node.tanqueSelected ? this.node.tanqueSelected : "tanque.png",
        tanks: Tanks.map(t => ({ value: t.src, text: this.$t(t.caption) }))
      }
    },

    watch: {
      imgSelected(value) {
        this.node.tanqueSelected = value
        let tankFounded = this.tanks.find(t => t.value == value)
        if(tankFounded)
          this.node.title = tankFounded.text
      }
    },

    methods: {
      
    },
    mounted() {
      
    },
  }
</script>

<style scoped>

.main{
  padding: 8px;
}

.img-tanque{
  width: 150px;
  margin-top: 16px;
  margin-left: calc(50% - 75px);
}

</style>